import { render, staticRenderFns } from "./editCompetitorModal.vue?vue&type=template&id=2ba2d596&"
import script from "./editCompetitorModal.vue?vue&type=script&lang=js&"
export * from "./editCompetitorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports